import {
  Box,
  Button,
  Card,
  Center,
  Checkbox,
  Group,
  Paper,
  Stack,
  Text,
  ThemeIcon,
} from '@mantine/core';
import { useElementSize } from '@mantine/hooks';
import { IconCheck } from '@tabler/icons-react';
import { useMutation, useSuspenseQuery } from '@tanstack/react-query';
import { useSearch } from '@tanstack/react-router';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FarmerLayout } from '../../components/farmer-layout/farmer-layout';
import { PDFViewer } from '../../components/pdf-viewer';
import { contractsApi } from '../../lib/apis/contracts';
import { useContractsQueries } from '../../lib/queries/contracts';
import 'core-js/full/url/can-parse';
import 'core-js/full/url/parse';
import 'core-js/proposals/promise-with-resolvers';
const root = import.meta.env.VITE_API_ROOT;

export const FarmerConsentPage: FC = () => {
  const { t } = useTranslation();
  const { token } = useSearch({
    from: '/farmer-consent',
  });
  const { ref, width } = useElementSize();
  const [isConsentChecked, setIsConsentChecked] = useState<boolean>(false);

  const queries = useContractsQueries();
  const info = useSuspenseQuery(queries.consentInfo(token));
  const sign = useMutation({
    mutationFn: contractsApi.consent.signConsent,
  });

  return (
    <FarmerLayout>
      <Stack gap="md" style={{ flex: 1, minHeight: 0 }}>
        {sign.isSuccess ? (
          <Center style={{ flex: 1 }} w="100%">
            <Card
              padding="lg"
              radius="md"
              shadow="sm"
              style={{ maxWidth: 500, width: '100%' }}
              withBorder
            >
              <Center mb="md">
                <Box bg="pf-green.1" p="md" style={{ borderRadius: '50%' }}>
                  <ThemeIcon
                    color="pf-green.6"
                    radius="xl"
                    size={60}
                    variant="filled"
                  >
                    <IconCheck size={24} />
                  </ThemeIcon>
                </Box>
              </Center>
              <Text c="pf-green.7" fw={500} mt="md" size="lg" ta="center">
                {t('farmer-consent.success')}
              </Text>
              <Text c="dimmed" mt="sm" size="sm" ta="center">
                {t('farmer-consent.success-message')}
              </Text>
            </Card>
          </Center>
        ) : (
          <>
            <Paper
              p={0}
              ref={ref}
              style={{
                flex: 1,
                overflow: 'auto',
                display: 'flex',
                justifyContent: 'center',
                maxWidth: '100%',
              }}
            >
              {info.data.file ? (
                <PDFViewer
                  file={`${root}${info.data.file}`}
                  width={width ? Math.min(width, 800) : 800}
                />
              ) : null}
            </Paper>
            <Group justify="end">
              <Stack>
                <Checkbox
                  checked={isConsentChecked}
                  label={t('farmer-consent.sign')}
                  onChange={(event) =>
                    setIsConsentChecked(event.currentTarget.checked)
                  }
                />
                <Button
                  disabled={!isConsentChecked}
                  loading={sign.isPending}
                  onClick={() => {
                    if (isConsentChecked) {
                      sign.mutate(token);
                    }
                  }}
                  size="md"
                >
                  {t('farmer-consent.confirmcta')}
                </Button>
              </Stack>
            </Group>
          </>
        )}
      </Stack>
    </FarmerLayout>
  );
};
